export default {
  CALENDAR: 'calendar',
  LIST: 'list',
};



// WEBPACK FOOTER //
// ./V7/events/listing/EventListingViewMode.js